import { Modal } from "../../atom/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
import { ParticipantFile } from "../../../types/components";
import { usePutResource } from "../../../services";
import { getFileStatus } from "../../../services/apiHelpers";

interface RemoveFileModalProps {
  file: ParticipantFile | null;
  isRemoveModalOpen: boolean;
  setIsRemoveModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  mutate: () => void;
}

export const RemoveFileModal: React.FC<RemoveFileModalProps> = ({
  file,
  isRemoveModalOpen,
  setIsRemoveModalOpen,
  mutate,
}) => {
  const { t } = useTranslation();
  const { updateResource } = usePutResource(`/common/participant-file/${file?.id}`);

  const removeFile = async () => {
    const status: [ParticipantFile["status"]] = await getFileStatus("not_uploaded");

    await updateResource({
      file_id: null,
      status_id: status?.[0].id,
    });

    mutate();

    setIsRemoveModalOpen(false);
  };

  return (
    <Modal
      isModalOpen={isRemoveModalOpen}
      closeModal={() => setIsRemoveModalOpen(false)}
      subtitle=""
      title={t("Remove file?")}
      titleIcon="⚠️"
      firstButtonLabel={t("Cancel")}
      secondButtonLabel={t("Yes, Remove")}
      content={
        <p className="text-black text-[16px] font-light leading-[140%] tracking-[0.2px] w-[496px] mb-[44px]">
          {t(
            "Confirm your action: once you remove this file, it cannot be recovered. Please double-check that you want to proceed.",
          )}
        </p>
      }
      firstButtonClick={() => setIsRemoveModalOpen(false)}
      secondButtonClick={removeFile}
      secondButtonType="danger-filled"
    />
  );
};
